import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SessionService } from '@app/session/session.service';
import { AppLoadingService, DialogService } from '@app/services';
import { PasswordRecoverySetupComponent } from '../components/password-recovery-setup/password-recovery-setup.component';
import { AppRoutes } from '@app/app-routes';
import { getServerConfig } from '@app/origami-api/server-config';

@Injectable({
  providedIn: 'root',
})
export class CheckSecretQuestionsProvidedService {
  constructor(
    private readonly session: SessionService,
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly appLoadingService: AppLoadingService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<never> {
    return this.checkSecretQuestionsProvided();
  }

  private checkSecretQuestionsProvided() {
    const resetPassConfig = !!this.session.domain.settings.security.resetPassword.enablePasswordRestore.get();
    const isIamEnabled = getServerConfig().IamEnabled;

    if (!resetPassConfig || isIamEnabled) {
      return of('');
    }

    const questionsNumber = this.session.domain.settings.security.resetPassword.requiredQuestionsNumber.get();
    const userInfo = this.session.user.details.AdditionalInfo;

    if (!userInfo || userInfo.PasswordResetAnswersCount >= questionsNumber) {
      // || TI.App.isUserSsoEnabled()   // check if correct number of answerss are provided, excluding SSO users
      return of('');
    }

    return Observable.create((obs) => {
      this.appLoadingService.hideLoading();

      this.dialogService.showDialog(
        PasswordRecoverySetupComponent,
        (instance: PasswordRecoverySetupComponent, close) => {
          instance.questionsCount = questionsNumber;
          instance.close$.subscribe((res) => {
            close(res);
            obs.complete();
            this.router.navigate([AppRoutes.Main], { queryParams: { passwordResetSuccess: true } });
          });
        },
      );
    });
  }
}
